var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPBv2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68005 39.3949L9.88816 41.8135C10.0037 42.0449 10.2271 42.2052 10.4855 42.2423L13.187 42.6301C13.8376 42.7235 14.0974 43.5135 13.6266 43.9669L11.6718 45.8495C11.4849 46.0296 11.3995 46.2889 11.4436 46.5432L11.9051 49.2014C12.0162 49.8416 11.336 50.3299 10.754 50.0277L8.3377 48.7726C8.10656 48.6525 7.83055 48.6525 7.59941 48.7726L5.18318 50.0277C4.60118 50.3299 3.92105 49.8417 4.03216 49.2014L4.49359 46.5432C4.53771 46.2889 4.45244 46.0296 4.26542 45.8495L2.31073 43.9669C1.83994 43.5135 2.09968 42.7235 2.75036 42.6301L5.45185 42.2423C5.71021 42.2052 5.93359 42.0449 6.04916 41.8135L7.25727 39.3949C7.54827 38.8124 8.38905 38.8124 8.68005 39.3949Z",
    stroke: "url(#paint0_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23567 6.00398C2.78296 6.52484 2.4136 7.13163 2.15556 7.81175C0.975516 10.9221 2.57085 14.3887 5.71899 15.5546C6.69851 15.9174 7.71281 16.0143 8.68106 15.8826L10.2035 17.4232C10.6319 17.8569 11.3772 17.5622 11.3846 16.9561L11.4106 14.8052C12.3555 14.1349 13.1169 13.1908 13.5558 12.0339C14.7359 8.92353 13.1406 5.45687 9.99242 4.29098C8.6345 3.78809 7.20981 3.79639 5.93343 4.21692",
    stroke: "url(#paint1_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9814 27.2598H12.7583C13.0872 27.2598 13.354 26.9963 13.354 26.6713V25.9376C13.354 24.8096 12.4285 23.8953 11.2868 23.8953H9.94843V23.1641C9.94843 22.0354 9.01356 21.0769 7.87136 21.098C6.76372 21.1185 5.87223 22.012 5.87223 23.1112V23.8953H4.53398C3.39231 23.8953 2.4668 24.8096 2.4668 25.9376V32.6094C2.4668 33.7373 3.39231 34.6517 4.53398 34.6517H11.2868C12.4285 34.6517 13.354 33.7373 13.354 32.6094V31.8757C13.354 31.5506 13.0872 31.2871 12.7583 31.2871H11.928C10.8154 31.2871 9.91101 30.4063 9.89028 29.3119C9.86891 28.1834 10.8391 27.2598 11.9814 27.2598Z",
    stroke: "url(#paint2_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0478 49.9144C46.048 49.9181 46.0474 49.9216 46.0476 49.9253H50.9572C52.9727 49.9253 54.6066 48.3108 54.6066 46.3193C54.6066 44.3278 52.9727 42.7134 50.9572 42.7134H21.6543C19.6388 42.7134 18.0049 44.3278 18.0049 46.3193C18.0049 48.3108 19.6388 49.9253 21.6543 49.9253H42.8592C42.859 49.9216 42.8584 49.9181 42.8583 49.9144",
    stroke: "url(#paint3_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.001 49.9254V42.7134",
    stroke: "url(#paint4_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9571 15.7715H21.6543C19.6388 15.7715 18.0049 14.157 18.0049 12.1655C18.0049 10.174 19.6388 8.55957 21.6543 8.55957H50.9571C52.9726 8.55957 54.6065 10.174 54.6065 12.1655C54.6065 14.157 52.9726 15.7715 50.9571 15.7715Z",
    stroke: "url(#paint5_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.79 15.7715V8.55957",
    stroke: "url(#paint6_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9571 32.8486H21.6543C19.6388 32.8486 18.0049 31.2342 18.0049 29.2427C18.0049 27.2512 19.6388 25.6367 21.6543 25.6367H50.9571C52.9726 25.6367 54.6065 27.2512 54.6065 29.2427C54.6065 31.2342 52.9726 32.8486 50.9571 32.8486Z",
    stroke: "url(#paint7_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3066 32.8486V25.6367",
    stroke: "url(#paint8_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4814 4.64209H37.3147",
    stroke: "url(#paint9_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4814 21.7212H44.1207",
    stroke: "url(#paint10_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4814 38.8003H40.6772",
    stroke: "url(#paint11_linear_1947_124)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1947_124",
    x1: 7.96866,
    y1: 38.958,
    x2: 7.96866,
    y2: 50.1194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1947_124",
    x1: 7.8557,
    y1: 3.90723,
    x2: 7.8557,
    y2: 17.6296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1947_124",
    x1: 7.91038,
    y1: 21.0977,
    x2: 7.91038,
    y2: 34.6517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1947_124",
    x1: 36.3058,
    y1: 42.7134,
    x2: 36.3058,
    y2: 49.9253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1947_124",
    x1: 49.501,
    y1: 42.7134,
    x2: 49.501,
    y2: 49.9254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1947_124",
    x1: 36.3057,
    y1: 8.55957,
    x2: 36.3057,
    y2: 15.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1947_124",
    x1: 42.29,
    y1: 8.55957,
    x2: 42.29,
    y2: 15.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1947_124",
    x1: 36.3057,
    y1: 25.6367,
    x2: 36.3057,
    y2: 32.8486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1947_124",
    x1: 36.8066,
    y1: 25.6367,
    x2: 36.8066,
    y2: 32.8486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1947_124",
    x1: 29.8981,
    y1: 4.64209,
    x2: 29.8981,
    y2: 5.64209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1947_124",
    x1: 33.3011,
    y1: 21.7212,
    x2: 33.3011,
    y2: 22.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1947_124",
    x1: 31.5793,
    y1: 38.8003,
    x2: 31.5793,
    y2: 39.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPBv2);
export default __webpack_public_path__ + "static/media/PBv2.3d2e3618cd30f16a65927dc8748a631c.svg";
export { ForwardRef as ReactComponent };